export default {
    namespaced: true,
    state: {
        contactMe: false,
        editProfile: false,
        searchbar: false,
        header: true
    },
    mutations: {
        contactMe(state,value) {
            state.contactMe = value
        },
        editProfile(state,value) {
            state.editProfile = value
        },
        searchbar(state,value) {
            state.searchbar = value
        },
        header(state,value) {
            state.header = value
        }
    }
}